import { useEffect } from 'react';
import PropTypes from 'prop-types';
import useOnScreen from 'hooks/useOnScreen';

const SectionItemTrigger = ({
  sectionIdx,
  sectionItem,
  sectionItemIdx,
  sectionItemOffset,
  setActiveSectionIdx,
  setActiveSectionItemIdx,
}) => {
  const target = document.getElementById(sectionItem.idTarget);
  const isSectionItemVisible = useOnScreen({}, target, '-51px 0px -85% 0px');

  useEffect(() => {
    if (isSectionItemVisible) {
      setActiveSectionIdx(sectionIdx);
      setActiveSectionItemIdx(sectionItemOffset + sectionItemIdx);
    }
  }, [isSectionItemVisible]);

  return null;
};

SectionItemTrigger.propTypes = {
  sectionIdx: PropTypes.number.isRequired,
  sectionItem: PropTypes.shape({
    title: PropTypes.string,
    idTarget: PropTypes.string,
  }).isRequired,
  sectionItemIdx: PropTypes.number.isRequired,
  sectionItemOffset: PropTypes.number.isRequired,
  setActiveSectionIdx: PropTypes.func.isRequired,
  setActiveSectionItemIdx: PropTypes.func.isRequired,
};

export default SectionItemTrigger;



// WEBPACK FOOTER //
// ./src-react/RankBrain2StickyNavbar/SectionItemTrigger.jsx